import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { CommonService } from 'src/app/_services/common.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { HeaderData } from 'src/app/_models/header-data';
import { LossControlService } from '../_services/loss-control.service';
import { ModalService } from 'src/app/_services/modal.service';
import { Modules } from 'src/app/_common/_enum/module.enum';
import { AuthenticationService } from 'src/app/user/_services/authentication.service';

@Component({
  selector: 'app-loss-control',
  templateUrl: './loss-control.component.html',
  styleUrls: ['./loss-control.component.scss']
})
export class LossControlComponent implements OnInit, OnDestroy {
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private loading = false;
  error = '';
  //private killServicesOnDestroy = [];

  constructor(private router: Router, 
              private commonService: CommonService, 
              private modalService : ModalService, 
              private lossControlService: LossControlService,
              private authenticationService: AuthenticationService) { }
              
  ngOnInit() {
    /* Sets Header Data */
    this.headerData = new HeaderData();
    this.setHeaderData();
  }

  setHeaderData(){
    this.headerData.pageTitle = "Loss Control";
    this.commonService.header = this.headerData;
  }

  get ModuleEnum(){
    return Modules;
  }
  //Using below method from HTML
  private accessURL(moduleName: string){
    return this.authenticationService.getModule(moduleName).link;
  }
  
  /* visitLostControlPortal() {
    window.open("https://losscontrol.prosightspecialty.com", '_blank');
  } */

  visitSafetyNow(moduleName: string){
    window.open(this.authenticationService.getModule(moduleName).link, '_blank');
  }

  openLossControlAccessModal(accessRequestTemplate) {
    this.loading = true; 
    let lossControlSubscription = this.lossControlService.lossControlPortalAccess().subscribe(data=>{
      console.log('Data : ');
      console.log(data);
      this.modalService.openModal(accessRequestTemplate);
    },
    error => {
        this.error = error;
        this.loading = false;
    });
    this.commonService.runningServices.push(lossControlSubscription);
  }
  
  ngOnDestroy() {
    this.commonService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}